<template>
  <!-- <v-row class="mt-4">
    <v-col :cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
      <v-card>
        <v-card-title>Chapel Policies</v-card-title>
        <link-list category="Chapel" />
      </v-card>
    </v-col>
  </v-row> -->
  <v-card class="ma-4">
    <v-toolbar>
      <v-toolbar-title>Chapel Policies</v-toolbar-title>
    </v-toolbar>
    <v-tabs v-model="tab">
      <v-tab v-for="{ title } in content" :key="title">{{ title }}</v-tab>
      <v-spacer />
      <v-btn @click="editActive = !editActive" class="mr-2" icon>
        <v-icon>{{ editActive ? 'fas' : 'fal' }} fa-pencil</v-icon>
      </v-btn>
      <v-dialog v-if="isAdmin" v-model="addPolicyDialog" width="400">
        <template v-slot:activator="{ on: dialogOn }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltipOn }">
              <v-btn v-on="{ ...dialogOn, ...tooltipOn }">
                <v-icon>fal fa-plus</v-icon>
              </v-btn>
            </template>
            <span>Add New Tab</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title>Add Section to Policies</v-card-title>
          <v-card-text>
            <v-text-field v-model="sectionTitle" label="Section Title" outlined />
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" text @click="addPolicySection">Add Section</v-btn>
            <v-spacer />
            <v-btn text @click="addPolicyDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="{ _id, title, content: html } in content" :key="html">
        <v-card v-if="isAdmin && editActive">
          <v-card-text>
            <html-editor :value="html" @change="(val) => saveContent(_id, val)" />
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-text v-html="html" />
          <v-card-text v-if="title === 'Makeup Policy'">
            <span>Scheduled makeup chapels this semester</span>
            <v-list>
              <v-list-item v-for="{ date, times } in makeupDates" :key="date">
                <v-list-item-content>
                  <v-list-item-title>{{ date }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip v-for="time in times" :key="date + '-' + time" class="mx-1">{{ time }}</v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-divider />
    <v-card-text>
      <p>Email julie.hess@covenant.edu with any questions about chapel attendance or exemption.</p>
      <p>Visit <a href="https://wwwcovenant.edu/students/chapel">covenant.edu/students/chapel</a> for more on the chapel program.</p>
    </v-card-text>
  </v-card>
</template>
<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import { stringFormatDate } from '@/helpers/formatters'

export default {
  components: {
    HtmlEditor: () => import('@/components/forms/HTMLEditor')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const tab = ref(0)

    const isAdmin = computed(() => user.value.roles.includes('Technology Services') || user.value.roles.includes('Chapel'))
    const editActive = ref(false)
    const content = ref([])
    const makeupDates = ref([])

    onMounted(async () => {
      const { data } = await root.$feathers.service('system/content').find({ query: { category: 'Chapel Policies', $sort: { title: 1 } } })
      content.value = data

      const dt = new Date()
      const term = dt.getFullYear() + (dt.getMonth() <= 5 ? '05' : '60')
      const aggregate = [
        { $match: { term, isMakeup: true } },
        { $project: {
          weekday: { $arrayElemAt: [['', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], { '$dayOfWeek': '$date' }] },
          date: { $dateToString: { format: '%b %d, %Y', date: '$date', timezone: 'America/New_York' } },
          time: { $dateToString: { format: '%H:%M', date: '$date', timezone: 'America/New_York' } }
        } },
        { $addFields: { date: { $concat: ['$weekday', ', ', '$date'] } } },
        { $group: { _id: '$date', times: { $addToSet: '$time' } } },
        { $sort: { date: 1 } },
        { $addFields: { times: { $sortArray: { input: '$times', sortBy: 1 } } } }
      ]
      const { data: termData } = await root.$feathers.service('chapel/schedule').find({ query: { aggregate } })
      makeupDates.value = termData
    })

    const addPolicyDialog = ref(false)
    const sectionTitle = ref('')
    async function addPolicySection () {
      const rec = await root.$feathers.service('system/content').create({ category: 'Chapel Policies', title: sectionTitle.value, createdBy: user.value.username, updatedBy: user.value.username })
      content.value.push(rec)
      sectionTitle.value = ''
      addPolicyDialog.value = false
    }

    async function saveContent (id, text) {
      await root.$feathers.service('system/content').patch(id, { content: text, updatedBy: user.value.username })
    }

    return {
      user,
      tab,
      isAdmin,
      editActive,
      content,
      makeupDates,
      addPolicyDialog,
      sectionTitle,
      addPolicySection,
      saveContent,
      stringFormatDate
    }
  }
}
</script>
